export const ltiToolRefs = [
  'metrica-dev',
  'metrica-qa',
  'metrica-uat',
  'metrica-sup',
  'metrica-perf',
  'metrica-prod1',
  'litmus-dev',
  'litmus-qa',
  'litmus-uat',
  'litmus-prod1',
  'litmus-perf',
  'litmus-sup'
]
